// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-hero {
  background: #eef1f6;
  padding: 0 0 72px;
}

.home-hero__announcement {
  background: #c81722;
  color: #fff;
  overflow: hidden;
  border-top: 1px solid rgba(255, 255, 255, 0.28);
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}

.home-hero__announcement-track {
  display: flex;
  width: max-content;
  animation: home-hero-marquee 8s linear infinite;
}

.home-hero__announcement:hover .home-hero__announcement-track,
.home-hero__announcement:active .home-hero__announcement-track {
  animation-play-state: paused;
}

.home-hero__announcement-item {
  margin: 0;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 32px;
  font-size: 0.96rem;
  font-weight: 700;
}

.home-hero__announcement-item a {
  color: #fff;
  text-decoration: underline;
  text-underline-offset: 2px;
}

@keyframes home-hero-marquee {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

.home-hero__inner {
  width: min(1140px, 92%);
  margin: 36px auto 0;
  display: grid;
  grid-template-columns: 1.02fr 0.98fr;
  gap: 44px;
  align-items: center;

}

.home-hero__badge {
  display: inline-block;
  margin: 0;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 0.83rem;
  font-weight: 700;
  color: #0f7a43;
  background: #d9efe2;
  border: 1px solid #b0dcc4;
}

.home-hero__title {
  margin: 18px 0 0;
  font-size: clamp(2.2rem, 4.2vw, 4rem);
  line-height: 1.08;
  color: #0f1a2e;
  letter-spacing: -0.03em;
}

.home-hero__title span {
  color: orange;
}

.home-hero__description {
  margin: 22px 0 0;
  max-width: 620px;
  font-size: 1.3rem;
  line-height: 1.65;
  color: #4d5d74;
}

.home-hero__actions {
  margin-top: 28px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.home-hero__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  padding: 0 22px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.98rem;
}

.home-hero__btn--primary {
  background: #2fb44f;
  color: #fff;
}

.home-hero__btn--secondary {
  background: #fff;
  color: #1a2740;
  border: 1px solid #d4dbe6;
}

.home-hero__features {
  margin: 18px 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.home-hero__features li {
  color: #3f5169;
  font-size: 1rem;
}

.home-hero__features li::before {
  content: "●";
  color: #29a94a;
  margin-right: 7px;
}

.home-hero__media img {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: 12px;
  margin-left: 5rem;
}

@media (max-width: 980px) {
  .home-hero {
    padding-bottom: 56px;
  }

  .home-hero__announcement-track {
    animation-duration: 12s;
  }

  .home-hero__announcement-item {
    font-size: 0.9rem;
    padding: 9px 24px;
  }

  .home-hero__inner {
    grid-template-columns: 1fr;
    gap: 30px;
    margin-top: 24px;
  }

  .home-hero__media img {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./home/hero/homeHero.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;;AAErB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".home-hero {\n  background: #eef1f6;\n  padding: 0 0 72px;\n}\n\n.home-hero__announcement {\n  background: #c81722;\n  color: #fff;\n  overflow: hidden;\n  border-top: 1px solid rgba(255, 255, 255, 0.28);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n}\n\n.home-hero__announcement-track {\n  display: flex;\n  width: max-content;\n  animation: home-hero-marquee 8s linear infinite;\n}\n\n.home-hero__announcement:hover .home-hero__announcement-track,\n.home-hero__announcement:active .home-hero__announcement-track {\n  animation-play-state: paused;\n}\n\n.home-hero__announcement-item {\n  margin: 0;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 32px;\n  font-size: 0.96rem;\n  font-weight: 700;\n}\n\n.home-hero__announcement-item a {\n  color: #fff;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n@keyframes home-hero-marquee {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(-50%);\n  }\n}\n\n.home-hero__inner {\n  width: min(1140px, 92%);\n  margin: 36px auto 0;\n  display: grid;\n  grid-template-columns: 1.02fr 0.98fr;\n  gap: 44px;\n  align-items: center;\n\n}\n\n.home-hero__badge {\n  display: inline-block;\n  margin: 0;\n  padding: 8px 14px;\n  border-radius: 999px;\n  font-size: 0.83rem;\n  font-weight: 700;\n  color: #0f7a43;\n  background: #d9efe2;\n  border: 1px solid #b0dcc4;\n}\n\n.home-hero__title {\n  margin: 18px 0 0;\n  font-size: clamp(2.2rem, 4.2vw, 4rem);\n  line-height: 1.08;\n  color: #0f1a2e;\n  letter-spacing: -0.03em;\n}\n\n.home-hero__title span {\n  color: orange;\n}\n\n.home-hero__description {\n  margin: 22px 0 0;\n  max-width: 620px;\n  font-size: 1.3rem;\n  line-height: 1.65;\n  color: #4d5d74;\n}\n\n.home-hero__actions {\n  margin-top: 28px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.home-hero__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 46px;\n  padding: 0 22px;\n  border-radius: 12px;\n  text-decoration: none;\n  font-weight: 700;\n  font-size: 0.98rem;\n}\n\n.home-hero__btn--primary {\n  background: #2fb44f;\n  color: #fff;\n}\n\n.home-hero__btn--secondary {\n  background: #fff;\n  color: #1a2740;\n  border: 1px solid #d4dbe6;\n}\n\n.home-hero__features {\n  margin: 18px 0 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.home-hero__features li {\n  color: #3f5169;\n  font-size: 1rem;\n}\n\n.home-hero__features li::before {\n  content: \"●\";\n  color: #29a94a;\n  margin-right: 7px;\n}\n\n.home-hero__media img {\n  display: block;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n  border-radius: 12px;\n  margin-left: 5rem;\n}\n\n@media (max-width: 980px) {\n  .home-hero {\n    padding-bottom: 56px;\n  }\n\n  .home-hero__announcement-track {\n    animation-duration: 12s;\n  }\n\n  .home-hero__announcement-item {\n    font-size: 0.9rem;\n    padding: 9px 24px;\n  }\n\n  .home-hero__inner {\n    grid-template-columns: 1fr;\n    gap: 30px;\n    margin-top: 24px;\n  }\n\n  .home-hero__media img {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
